var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2336 9.34676C10.2336 13.2374 13.3949 16.4035 17.2796 16.4035C21.1643 16.4035 24.3257 13.2374 24.3257 9.34676C24.3257 5.45616 21.1643 2.29004 17.2796 2.29004C13.3949 2.29004 10.2336 5.45616 10.2336 9.34676ZM29.8059 32.0851H31.3717V30.5169C31.3717 24.4654 26.4536 19.5398 20.4112 19.5398H14.148C8.10408 19.5398 3.1875 24.4654 3.1875 30.5169V32.0851H29.8059Z",
    fill: "#DE007A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/human.818c355cd45a3d5858afdb370c32e297.svg";
export { ForwardRef as ReactComponent };